const mutations = {
    setService(state, data) {
        const service = Object.assign({
            label: '',
            serviceCategoryId: null,
            serviceCategoryIds: [],
        }, data || {});
        const serviceCategoryIds = [];
        const rawIds = Array.isArray(service.serviceCategoryIds) ? service.serviceCategoryIds : [];
        rawIds.forEach((id) => {
            if (id && serviceCategoryIds.indexOf(id) === -1) serviceCategoryIds.push(id);
        });
        if (!serviceCategoryIds.length && service.serviceCategoryId) {
            serviceCategoryIds.push(service.serviceCategoryId);
        }
        service.serviceCategoryIds = serviceCategoryIds;
        service.serviceCategoryId = serviceCategoryIds[0] || null;
        state.service = service;
    },
    setServiceList(state, data) {
        state.serviceList = data;
    },
    resetService(state) {
        state.service = {
            label: '',
            serviceCategoryId: null,
            serviceCategoryIds: [],
        }

    }
}
export default mutations;